// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateEcuadorianPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim()) {
    return { id: 'empty' };
  } else if (!parseInt(phoneNumberValue) || !/^\d{1,20}$/.test(phoneNumberValue)) {
    return { id: 'invalid-pattern' };
  }
}
